<template>
  <div>
    <Master :pageTitle="pageTitle">
      <template #button>
        <div class="rightBtn">
          <template v-if="authority.isAdmin">
            <a
              class="linkText--text csvSampleStyle font-weight-bold"
              :href="csvSampleUrl"
              target="_blank"
            >
              {{ '※' + $t('common.common_csv-sample') }}
            </a>
            <label class="fileInputLabel">
              {{ $t('common.common_csv-import') }}
              <input
                ref="file"
                type="file"
                class="fileInput"
                @change="fileSelected"
              />
            </label>
          </template>
          <NormalButton
            :text="buttonName"
            height="32px"
            width="150px"
            class="text-right"
            @click="dialogInfo.register = true"
          />
          <JdProductDialog
            v-model="dialogInfo.register"
            @success="registerSuccess"
          />
        </div>
      </template>
      <template #list>
        <div class="jdProductTable">
          <JdProductTable
            :headers="headers"
            :jdProductItems="getJdproductListFromState()"
            :item-key="itemKey"
          >
            <template #invisibleFlg="{ item }">
              {{ getJdProductStatus(item.invisibleFlg) }}
            </template>
            <template #edit="{ item }">
              <WhiteButton
                text="common.common_edit"
                height="32px"
                width="48px"
                @click="edit(item)"
              />
            </template>
          </JdProductTable>
        </div>
      </template>
    </Master>
    <JdProductDialog
      v-model="dialogInfo.edit"
      :jdProductData="jdProductData"
      :editMode="true"
      @success="editSuccess"
    />
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import headers from './headers'
import { Master } from '@/components/layouts'
import JdProductTable from './JdProductTable'
import { NormalButton, WhiteButton } from '@/components/items'
import { JdProductDialog } from '@/components/layouts/Dialogs'
import _cloneDeep from 'lodash/cloneDeep'

export default {
  components: {
    Master,
    JdProductDialog,
    NormalButton,
    WhiteButton,
    JdProductTable
  },
  data: () => {
    return {
      pageTitle: 'jd.jd_jdcom-product-management',
      buttonName: 'jd.jd_jdcom-product-registration',
      jdProductData: {},
      headers: headers.headers,
      itemKey: 'jdproductId',
      dialogInfo: {
        register: false,
        edit: false
      },
      editMode: false,
      uploadFile: ''
    }
  },
  async created() {
    this.init()
  },
  methods: {
    ...mapActions('Jdproduct', [
      'getJdproductListFromApi',
      'bulkRegisterJdproduct'
    ]),
    ...mapGetters('Jdproduct', ['getJdproductListFromState']),

    async init() {
      await this.getJdproductListFromApi()
    },
    getJdProductStatus(invisibleFlg) {
      return invisibleFlg
        ? this.$t('common.common_hide')
        : this.$t('common.common_normal')
    },
    edit(jdProduct) {
      this.jdProductData = _cloneDeep(jdProduct)
      this.dialogInfo.edit = true
    },
    registerSuccess() {
      this.init()
      this.dialogInfo.register = false
    },
    editSuccess() {
      this.init()
      this.dialogInfo.edit = false
    },
    async fileSelected(event) {
      this.uploadFile = event.target.files[0]

      const formData = new FormData()
      formData.append('uploadFile', this.uploadFile)
      const uploadData = await this.bulkRegisterJdproduct(formData)
      if (uploadData) {
        const nameList = uploadData.data.registeredExProductList.map((ele) => {
          return ele.name
        })
        const nameListStr = nameList.join(', ')

        alert(`${this.$t('common.common_register-result')}
      ${nameListStr}
              `)
        this.init()
      }

      this.$refs.file.value = '' // 初期化
    }
  },
  computed: {
    ...mapGetters('User', ['authority']),
    csvSampleUrl() {
      let url = ''
      switch (process.env.VUE_APP_ENV_NAME) {
        case 'production':
          url =
            'https://order-assets.spe-s.com/sample/master-upload/exproduct_upload_sample_20220609.zip'
          break
        case 'staging':
          url =
            'https://stg-order-assets.spe-s.com/sample/master-upload/exproduct_upload_sample_20220609.zip'
          break
        default:
          url =
            'https://dev-order-assets.spe-s.com/sample/master-upload/exproduct_upload_sample_20220609.zip'
      }
      return url
    }
  }
}
</script>
<style scoped lang="scss">
.jdProductTable {
  ::v-deep .v-data-table td:last-child {
    padding: 0 8px !important;
  }
}
.rightBtn {
  display: flex;
  justify-content: flex-end;
}
.fileInput {
  display: none;
}
.csvSampleStyle {
  width: 88px;
  height: 12px;
  margin: 8px 12px 0px 0px;
  font-size: 12px;
  text-decoration: none;
}
.fileInputLabel {
  width: 108px;
  height: 32px;
  margin: 0px 12px 0px 0px;
  padding: 7px 9px 11px 11px;
  border-radius: 4px;
  border: solid 1px #c8cfd7;
  background-color: #fff;
  font-size: 12px;
  color: #6a6a6a;
}
</style>
